import { FC, useState } from 'react';
import { MessageComposerType } from './enums';
import { TextMessageComposer } from './TextMessageComposer';
import { VoiceMessageComposer } from './VoiceMessageComposer';
// simple composer — no typography component required

export type MessageComposerProps = {
  placeholder?: string;
  onSubmit: (text: string, files?: File[]) => void | Promise<void>;
  autoFocus?: boolean;
};

export const MessageComposer: FC<MessageComposerProps> = ({ onSubmit, autoFocus = false }) => {
  const [type, setType] = useState(MessageComposerType.TEXT);
  const [submitting, setSubmitting] = useState(false);

  const handleTextSubmit = async (text: string, files?: File[]) => {
    setSubmitting(true);
    try {
      await onSubmit(text.trim(), files);
    } finally {
      setSubmitting(false);
    }
  };

  const handleVoiceSubmit = (blobs: Blob[]) => {
    if (!blobs.length) {
      return;
    }

    setSubmitting(true);
    const placeholder = `Voice message received (${blobs.length} part${blobs.length > 1 ? 's' : ''}).`;
    Promise.resolve(onSubmit(placeholder)).finally(() => setSubmitting(false));
  };

  if (type === MessageComposerType.VOICE) {
    return (
      <div className="w-full px-3 md:px-0">
        <div className="mx-auto w-full max-w-[860px] p-5 bg-grey-main rounded-xl flex items-center gap-4">
          <VoiceMessageComposer
            submitting={submitting}
            onSubmit={handleVoiceSubmit}
            onSwitchType={() => setType(MessageComposerType.TEXT)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="w-full px-3 md:px-0">
      <div className="mx-auto w-full max-w-[860px] self-center h-fit min-h-[80px] py-4 pr-6 bg-white dark:bg-grey-black border border-peach-1 rounded-[24px] flex items-center gap-0">
        <TextMessageComposer
          autoFocus={autoFocus}
          submitting={submitting}
          onSubmit={handleTextSubmit}
          onSwitchType={() => setType(MessageComposerType.VOICE)}
        />
      </div>
    </div>
  );
};

export default MessageComposer;
